import { RangeField } from "./range-field.model";

export class SpendingDistributionRequest {
  constructor (public age: RangeField,
               public states: string[] = [],
               public subnationalCode?: string) {}

  public copy() {
    return new SpendingDistributionRequest(this.age, this.states, this.subnationalCode);
  }
}
